module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-disney-4-2caff0025b2063a1f4c1087490d9ea9d.webp";